import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const toggleHiddenModelId = (modelId: string) => (model: Model) => {
  const currentHiddenModels = [...model.modelData.hiddenModelIds];
  if (currentHiddenModels.includes(modelId)) {
    currentHiddenModels.splice(currentHiddenModels.indexOf(modelId), 1);
  } else {
    currentHiddenModels.push(modelId);
  }
  setDataProperty<ModelData>(model)(
    model.modelData,
    'hiddenModelIds',
    currentHiddenModels
  );
};
